// Mock data for Transpost website - Enterprise Consulting & Software Development

export const mockServices = [
  {
    id: 1,
    title: "AI Strategy & Consulting",
    description: "We start with vision, not technology. Discover where AI can fundamentally transform your business - from customer experience to sales optimization and finance automation. We help you see the future of your industry and build a strategic roadmap to get there, prioritizing use cases by value and feasibility.",
    icon: "Brain",
    features: ["AI Opportunity Assessment", "Use Case Identification & Prioritization", "ROI Analysis & Business Case", "AI Transformation Roadmap", "Risk Mitigation Strategy", "Vision & Future State Planning"],
    pricing: "Custom Engagement"
  },
  {
    id: 2,
    title: "AI Development & Implementation",
    description: "Building AI that works for your business. We develop custom AI solutions, machine learning models, and intelligent automation systems tailored to your specific use cases. From predictive analytics to NLP, computer vision, and RAG systems - we build AI that delivers measurable business outcomes.",
    icon: "Build",
    features: ["Custom AI Solutions", "Machine Learning Models", "Intelligent Automation", "Predictive Analytics", "NLP & Computer Vision", "RAG & LLM Integration", "AI Agent Development"],
    pricing: "Project-Based or Dedicated Teams"
  },
  {
    id: 3,
    title: "Software Development & Engineering",
    description: "Applications built with tomorrow in mind. We develop enterprise-grade software that's AI-ready and future-proof. From custom applications to product engineering, we build software that can evolve with AI capabilities and scale with your business growth.",
    icon: "Code",
    features: ["AI-Enabled Applications", "Custom Enterprise Software", "Product Engineering", "Legacy System Modernization", "API & Microservices", "Full-Stack Development", "Cloud-Native Architecture"],
    pricing: "Project-Based or Dedicated Teams"
  },
  {
    id: 4,
    title: "Digital Transformation",
    description: "Transforming operations, not just upgrading systems. We help enterprises reimagine how they operate through AI-first digital transformation. Modernize legacy systems, migrate to cloud-native architectures, and digitize processes with AI capabilities at the core - enabling agility, innovation, and competitive advantage.",
    icon: "Zap",
    features: ["AI-First Digital Strategy", "Legacy Modernization", "Cloud Migration", "Process Reimagination", "System Integration", "Change Management", "Future-Ready Architecture"],
    pricing: "Multi-Phase Engagement"
  },
  {
    id: 5,
    title: "Cloud & DevOps",
    description: "Accelerate delivery with cloud-native architectures and DevOps best practices. We design, migrate, and manage cloud infrastructure while implementing CI/CD pipelines, infrastructure as code, and automated monitoring solutions.",
    icon: "Cloud",
    features: ["Cloud Architecture & Migration", "DevOps Implementation", "CI/CD Pipelines", "Infrastructure as Code", "Container Orchestration", "Performance Optimization"],
    pricing: "Project-Based or Managed Services"
  },
  {
    id: 6,
    title: "Cybersecurity & Compliance",
    description: "Comprehensive security services to protect your digital infrastructure. We implement security frameworks, conduct audits, ensure compliance, and provide 24/7 monitoring to safeguard your critical business assets.",
    icon: "Shield",
    features: ["Security Audits & Assessments", "Penetration Testing", "Compliance Management", "Security Architecture", "24/7 Monitoring", "Incident Response"],
    pricing: "Custom Engagement"
  }
];

export const mockPortfolio = [
  {
    id: 1,
    title: "AI-First Customer Experience Transformation",
    category: "AI Consulting",
    description: "Transformed customer experience for a global enterprise by implementing AI-powered personalization, intelligent chatbots, and predictive service systems. Identified high-value use cases through strategic AI assessment and built custom solutions that delivered measurable improvements in customer satisfaction and retention.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=500&h=300&fit=crop",
    technologies: ["AI Strategy", "Machine Learning", "NLP", "Personalization Engines", "Predictive Analytics"],
    results: "40% increase in customer satisfaction, 50% reduction in support costs, 35% improvement in customer lifetime value"
  },
  {
    id: 2,
    title: "AI-Powered Sales Optimization Platform",
    category: "AI Consulting",
    description: "Developed and deployed AI-driven sales platform with predictive lead scoring, automated forecasting, and dynamic pricing optimization for a Fortune 500 company. The solution transformed their sales organization from reactive to predictive, enabling data-driven decision making at scale.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=500&h=300&fit=crop",
    technologies: ["AI Strategy", "Predictive Analytics", "Machine Learning", "Sales Automation", "Dynamic Pricing"],
    results: "45% increase in win rates, 60% improvement in forecast accuracy, 30% faster sales cycles"
  },
  {
    id: 3,
    title: "Intelligent Finance & Accounts Automation",
    category: "AI Consulting",
    description: "Implemented AI-powered finance transformation for a financial services leader, automating invoice processing, reconciliation, and fraud detection. Built custom AI solutions that reduced manual effort while improving accuracy and providing real-time financial insights.",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=500&h=300&fit=crop",
    technologies: ["AI Strategy", "OCR & Document AI", "Machine Learning", "Process Automation", "Fraud Detection"],
    results: "80% reduction in processing time, 90% decrease in errors, 60% fraud prevention improvement"
  },
  {
    id: 4,
    title: "AI-Enabled Digital Transformation",
    category: "Digital Transformation",
    description: "Led comprehensive AI-first digital transformation for an enterprise, modernizing legacy systems with AI capabilities at the core. Built cloud-native architecture with integrated AI services, enabling the organization to stay ahead of technology trends and scale with intelligent automation.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=500&h=300&fit=crop",
    technologies: ["AI Strategy", "Cloud Architecture", "AI/ML Integration", "Legacy Modernization", "Microservices"],
    results: "40% reduction in operational costs, 3x faster time-to-market, future-ready architecture"
  }
];

export const mockTeam = [
  {
    id: 1,
    name: "Alex Rodriguez",
    position: "Chief Technology Officer",
    bio: "20+ years leading technology transformations for Fortune 500 companies. Expert in enterprise architecture, digital strategy, and scaling high-performance engineering teams. Previously held senior technology roles at leading consulting firms.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&face=top",
    linkedin: "#",
    twitter: "#"
  },
  {
    id: 2,
    name: "Sarah Chen",
    position: "Director of AI & Machine Learning",
    bio: "AI and data science leader with 15+ years building intelligent systems for enterprise clients. Specializes in AI strategy, machine learning implementation, and helping organizations scale AI capabilities across business functions.",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=300&h=300&fit=crop&face=top",
    linkedin: "#",
    twitter: "#"
  },
  {
    id: 3,
    name: "Michael Johnson",
    position: "Head of Software Engineering",
    bio: "Engineering leader with extensive experience in enterprise software development, cloud-native architectures, and product engineering. Has led development of mission-critical systems serving millions of users.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop&face=top",
    linkedin: "#",
    twitter: "#"
  },
  {
    id: 4,
    name: "Emily Davis",
    position: "Principal Digital Transformation Consultant",
    bio: "Digital transformation expert helping enterprises modernize legacy systems and adopt cloud-native architectures. Specializes in change management, process optimization, and technology strategy alignment.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&h=300&fit=crop&face=top",
    linkedin: "#",
    twitter: "#"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "David Thompson",
    company: "Global Enterprise Client",
    position: "Chief Information Officer",
    content: "Transpost has been an exceptional partner in our digital transformation journey. Their strategic consulting approach, combined with deep technical expertise, helped us modernize our legacy systems and implement AI solutions that have delivered measurable business value. Their team's professionalism and commitment to excellence is outstanding.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop&face=top"
  },
  {
    id: 2,
    name: "Lisa Martinez",
    company: "Fortune 500 Manufacturing",
    position: "VP of Digital Transformation",
    content: "Working with Transpost has been transformative for our organization. Their AI consulting services helped us identify and implement intelligent automation solutions that reduced operational costs by 40% while improving accuracy. Their ability to understand our business context and deliver solutions that align with our strategic objectives sets them apart.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&face=top"
  },
  {
    id: 3,
    name: "Robert Kim",
    company: "Leading Financial Services",
    position: "Chief Technology Officer",
    content: "Transpost's software development team delivered enterprise-grade solutions that exceeded our expectations. Their expertise in cloud-native architectures and modern development practices enabled us to scale our operations while maintaining the highest standards of security and compliance. They're not just vendors - they're true technology partners.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1566492031773-4f4e44671d66?w=100&h=100&fit=crop&face=top"
  }
];

export const mockCompanyStats = {
  yearsOfExperience: 10,
  projectsCompleted: 500,
  clientSatisfaction: 98,
  teamMembers: 150,
  countriesServed: 25
};

export const mockContactInfo = {
  email: "info@transpost.co",
  phone: "+1 (555) 123-4567",
  address: "Suite 4, Level 8, Time Square Building, Andheri - Kurla Rd, B Wing, Chimatpada, Marol, Andheri East, Mumbai, Maharashtra 400059",
  workingHours: "Monday - Friday: 9:00 AM - 6:00 PM PST"
};

// Use Cases - How AI transforms business functions
export const mockUseCases = [
  {
    id: 1,
    title: "Customer Experience Transformation",
    description: "Reimagine how you engage with customers through AI-powered personalization, intelligent chatbots, predictive service, and sentiment analysis. Transform customer interactions from reactive to proactive, delivering experiences that drive loyalty and lifetime value.",
    icon: "Users",
    applications: [
      {
        name: "AI-Powered Personalization",
        description: "Deliver personalized experiences at scale using machine learning to understand customer preferences and behavior"
      },
      {
        name: "Intelligent Chatbots & Virtual Assistants",
        description: "24/7 customer support with AI agents that understand context and resolve issues instantly"
      },
      {
        name: "Predictive Customer Service",
        description: "Anticipate customer needs and proactively address issues before they escalate"
      },
      {
        name: "Sentiment Analysis & Feedback Automation",
        description: "Understand customer sentiment in real-time and automate response to feedback across all channels"
      }
    ],
    outcomes: ["Increase customer satisfaction by 40%", "Reduce support costs by 50%", "Improve customer lifetime value by 35%", "Decrease churn by 30%"],
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=500&h=300&fit=crop"
  },
  {
    id: 2,
    title: "Sales & Revenue Optimization",
    description: "Accelerate revenue growth through AI-driven lead scoring, sales forecasting, dynamic pricing, and sales process automation. Transform your sales organization from reactive to predictive, closing more deals faster with higher win rates.",
    icon: "TrendingUp",
    applications: [
      {
        name: "AI-Driven Lead Scoring & Qualification",
        description: "Identify high-value prospects automatically and prioritize sales efforts for maximum conversion"
      },
      {
        name: "Predictive Sales Forecasting",
        description: "Accurate revenue predictions using machine learning to analyze historical data and market trends"
      },
      {
        name: "Dynamic Pricing Optimization",
        description: "Optimize pricing in real-time based on demand, competition, and customer behavior"
      },
      {
        name: "Sales Process Automation",
        description: "Automate repetitive tasks, follow-ups, and pipeline management to accelerate sales cycles"
      }
    ],
    outcomes: ["Increase win rates by 45%", "Improve forecast accuracy by 60%", "Accelerate sales cycles by 30%", "Boost revenue by 25%"],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=500&h=300&fit=crop"
  },
  {
    id: 3,
    title: "Finance & Accounts Automation",
    description: "Streamline financial operations with intelligent invoice processing, automated reconciliation, fraud detection, and financial forecasting. Transform finance from manual, error-prone processes to intelligent, automated systems that provide real-time insights.",
    icon: "DollarSign",
    applications: [
      {
        name: "Intelligent Invoice Processing",
        description: "Automate invoice capture, validation, and processing with AI-powered OCR and data extraction"
      },
      {
        name: "Automated Reconciliation",
        description: "Match transactions automatically across systems, reducing manual effort and errors"
      },
      {
        name: "AI-Powered Fraud Detection",
        description: "Identify fraudulent transactions in real-time using machine learning pattern recognition"
      },
      {
        name: "Financial Forecasting & Planning",
        description: "Predict cash flow, revenue, and expenses with AI models that learn from historical patterns"
      }
    ],
    outcomes: ["Reduce processing time by 80%", "Decrease errors by 90%", "Prevent fraud losses by 60%", "Improve cash flow visibility by 100%"],
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=500&h=300&fit=crop"
  }
];

// Industries with specific AI applications
export const mockIndustries = [
  {
    id: 1,
    name: "Freight Forwarding & Logistics",
    description: "Transform logistics operations with AI-powered route optimization, demand forecasting, and automated documentation. Reduce costs, improve delivery times, and enhance customer satisfaction.",
    icon: "Truck",
    aiApplications: [
      "Route Optimization & Planning",
      "Demand Forecasting",
      "Automated Documentation",
      "Real-time Tracking & Visibility",
      "Predictive Maintenance",
      "Dynamic Pricing"
    ],
    outcomes: "30% cost reduction, 25% faster delivery, 95% on-time performance",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=500&h=300&fit=crop"
  },
  {
    id: 2,
    name: "Travel & Hospitality",
    description: "Optimize revenue and operations with AI-driven dynamic pricing, demand prediction, booking optimization, and personalized customer experiences.",
    icon: "Plane",
    aiApplications: [
      "Dynamic Pricing Optimization",
      "Demand Prediction",
      "Booking Management",
      "Personalized Recommendations",
      "Customer Service Automation",
      "Revenue Management"
    ],
    outcomes: "40% revenue increase, 35% better pricing, 50% faster bookings",
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=500&h=300&fit=crop"
  },
  {
    id: 3,
    name: "E-commerce & Retail",
    description: "Drive growth through AI-powered personalization, intelligent inventory management, dynamic pricing, and omnichannel customer experiences.",
    icon: "ShoppingCart",
    aiApplications: [
      "Personalized Product Recommendations",
      "Intelligent Inventory Management",
      "Dynamic Pricing",
      "Customer Behavior Analysis",
      "Supply Chain Optimization",
      "Chatbot & Virtual Shopping Assistants"
    ],
    outcomes: "40% conversion increase, 30% inventory reduction, 50% customer satisfaction boost",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=500&h=300&fit=crop"
  }
];

// Products for specific industries
export const mockProducts = [
  {
    id: 1,
    title: "Freight Forwarding Management System",
    description: "Comprehensive freight forwarding software solution designed for logistics companies. Streamlines operations from booking to delivery with real-time tracking, automated documentation, and integrated financial management.",
    category: "Logistics & Transportation",
    features: ["Booking Management", "Real-time Tracking", "Document Automation", "Financial Integration", "Multi-carrier Support"],
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=500&h=300&fit=crop"
  },
  {
    id: 2,
    title: "Enterprise Invoicing Platform",
    description: "Modern invoicing and billing software for enterprises. Automates invoice generation, payment processing, and financial reporting with seamless integration to accounting systems and payment gateways.",
    category: "Financial Software",
    features: ["Automated Invoicing", "Payment Processing", "Multi-currency Support", "Accounting Integration", "Analytics & Reporting"],
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=500&h=300&fit=crop"
  },
  {
    id: 3,
    title: "Travel Management System",
    description: "End-to-end travel software solution for travel agencies and corporate travel departments. Manages bookings, itineraries, expenses, and provides comprehensive reporting and analytics.",
    category: "Travel & Hospitality",
    features: ["Booking Management", "Itinerary Planning", "Expense Management", "Multi-supplier Integration", "Mobile App"],
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=500&h=300&fit=crop"
  },
  {
    id: 4,
    title: "Modern E-commerce & Omnichannel Platform",
    description: "Next-generation e-commerce platform with omnichannel capabilities. Enables seamless shopping experiences across web, mobile, and physical stores with unified inventory, order management, and customer data.",
    category: "E-commerce",
    features: ["Omnichannel Commerce", "Unified Inventory", "Order Management", "Customer Analytics", "Mobile Commerce", "API-First Architecture"],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=500&h=300&fit=crop"
  }
];